export class MutatorUserError extends Error {
  reason: string

  constructor(reason: string) {
    super('Mutator user error')
    this.reason = reason
    this.message = reason
  }
}
